import { render } from "./weighingsCard.vue?vue&type=template&id=41bc4ae1&scoped=true"
import script from "./weighingsCard.vue?vue&type=script&lang=js"
export * from "./weighingsCard.vue?vue&type=script&lang=js"

import "./weighingsCard.vue?vue&type=style&index=0&id=41bc4ae1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bc4ae1"]])

export default __exports__